/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import Picture from 'components/Picture/Picture';
import VideoBackground from 'components/VideoBackground/VideoBackground';
import './SpannedImageText.scss';

const DEFAULT_IMAGE: ComponentProps<typeof Picture> = {};

interface SpannedImageTextProps {
  layout?: 'left' | 'right';
  image?: ComponentProps<typeof Picture>;
  video?: ComponentProps<typeof VideoBackground>;
  text?: string;
  photographer?: string;
}

/**
 * This is the SpannedImageText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function SpannedImageText({
  layout = 'left',
  image = DEFAULT_IMAGE,
  video,
  text = '',
  photographer = '',
}: SpannedImageTextProps) {
  function renderVideo() {
    if (!video) return null;
    return <VideoBackground {...video} />;
  }

  function renderPhotographer() {
    if (!photographer) return null;

    return <small className="photographer">{photographer}</small>;
  }

  return (
    <div className={`block spanned-image-text layout-${layout}`}>
      <div className="image" appear="true">
        <Picture {...image} />
        {renderVideo()}
      </div>
      <div className="text">
        <p dangerouslySetInnerHTML={{ __html: text }} stagger-text="true" />
      </div>
      {renderPhotographer()}
    </div>
  );
}

export default SpannedImageText;
